
function NeedTour() {
  return (
    <div
      className="relative w-full my-8 bg-cover bg-center bg-no-repeat rounded-lg"
      style={{
        backgroundImage: "url('/images/black-tour-guide.png')",
        minHeight: "300px", // You can adjust height
      }}
    >
      {/* Overlay Content Inside the Image */}
      <div className="absolute inset-x-4 bottom-4 flex flex-col md:flex-row items-start md:items-center justify-between bg-black/60 text-white p-4 gap-4 rounded-lg">
        <div className="text-sm md:text-base md:max-w-[60%]">
          <p className="font-semibold text-base md:text-lg mb-1">
            Need a Ride for Your Tour?
          </p>
          <p className="leading-tight">
            Easily book a ride to your meetup point or for the entire tour.
          </p>
        </div>

        <button className="w-full md:w-1/4 bg-[#570033] text-white py-2 px-4 rounded text-sm md:text-base">
          Book Now
        </button>
      </div>
    </div>
  );
}

export default NeedTour;


// function NeedTour() {
//   return (
//     <div className="relative w-full my-8">
//       <img
//         src="/images/black-tour-guide.png"
//         alt="Tour-guide"
//         className="w-full object-cover block"
//       />

//       {/* <div className="absolute left-4 right-4 bottom-4 flex flex-col md:flex-row p-4 gap-4 items-start md:items-center justify-between bg-black/60 text-white rounded-lg"> */}
//       <div className="absolute left-4 right-4 bottom-4 flex flex-col md:flex-row p-4 gap-4 items-start md:items-center justify-between text-white rounded-lg">
//         <div className="text-sm md:text-base">
//           <p className="font-semibold">Need a Ride for Your Tour?</p>
//           <p>
//             Easily book a ride to your meetup point or for the entire tour.
//           </p>
//         </div>

//         <button className="w-full md:w-1/4 bg-[#570033] text-white py-2 px-4 rounded text-sm md:text-base">
//           Book Now
//         </button>
//       </div>
//     </div>
//   );
// }

// export default NeedTour;


// function NeedTour() {
//   return (
//     <div className="relative w-full my-8">
//       <img
//         src="/images/black-tour-guide.png"
//         alt="Tour-guide"
//         className="w-full object-cover block"
//       />

//       <div className="absolute left-12 bottom-8 flex p-4 w-[90%] gap-2 items-center justify-between text-white">
//         <div>
//           <p>Need a Ride for Your Tour?</p>
//           <p>
//             Easily book a ride to your meetup point or for the the entire tour.
//           </p>
//         </div>

//         <button className="p-2 bg-[#570033] text-white w-[30%] rounded">Book Now</button>
//       </div>
//     </div>
//   );
// }

// export default NeedTour;